import { FluidForm, formatInferredValue } from '../../shared';
import React from 'react';
const FieldDataRenderer = ({ formKey, fieldKey, value, formConfig, style, className }) => {
    let fieldConfig = null;
    if (formConfig) {
        const formConfigService = new FluidForm(formConfig);
        fieldConfig = formConfigService.getFieldConfigByFieldPath(fieldKey);
    }
    // Handle null or undefined values
    if (value === null || value === undefined) {
        return (React.createElement("span", { style: { color: '#ccc', fontStyle: 'italic', ...style }, className: className }, "\u2014"));
    }
    // Use formatInferredValue if we have fieldConfig
    let formattedValue = value;
    if (fieldConfig) {
        try {
            formattedValue = formatInferredValue(value, fieldConfig);
        }
        catch (error) {
            console.warn('Error formatting field value:', error);
            formattedValue = value; // Fallback to original value
        }
    }
    // Handle object values (format as JSON)
    if (typeof formattedValue === 'object') {
        return (React.createElement("pre", { style: {
                fontSize: '0.85rem',
                margin: 0,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                backgroundColor: '#f8f9fa',
                padding: '4px 6px',
                borderRadius: '3px',
                border: '1px solid #e9ecef',
                maxWidth: '300px',
                overflow: 'auto',
                ...style
            }, className: className }, JSON.stringify(formattedValue, null, 2)));
    }
    // Handle primitive values
    return (React.createElement("span", { style: style, className: className }, String(formattedValue)));
};
export default FieldDataRenderer;
